import {SyntheticEvent} from 'react';

export function stopPropagationEvent(e: Event | SyntheticEvent) {
  e.stopPropagation();
}
